import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isCellEdited: false,
};

export const editSingleCellOfTherapyPlanningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS: {
      return {
        ...state,
        response: action.payload?.response,
        loading: false,
        isCellEdited: true,
        editedCellPayload: action.payload?.requestedPayload,
      };
    }

    case EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isCellEdited: false,
      };
    case EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET:
      return intitialstate;

    default:
      return state;
  }
};
